import type { ClientItem } from "../types/Client";


export function hasAnySurveyAnswered(row: ClientItem): boolean {
  const list: any[] | undefined = (row as any).surveyHistoryList;
  if (Array.isArray(list)) {
    return list.some(
      s => s?.completed === true || s?.isCompleted === true
    );
  }

  const anyCount = (row as any).surveyAnsweredCount;
  if (typeof anyCount === "number") return anyCount > 0;

  return false;
}